import { fromFetch } from 'rxjs/fetch';

import { csvHeaders } from '../../../models/csv-headers';
import { selectBlob } from '../../../utils/select-blob';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';

/**
 * Exports Drivers
 * @returns A CSV file containing the exported drivers
 */
export function getDriversExport(this: unknown) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(fleetEnvironment.resolve(this).driversExportUrl, {
        method: 'GET',
        headers: {
          ...csvHeaders,
          ...jwtAuthHeaders,
        },
      })
    )
  ).pipe(selectBlob());
}
